import React, { useEffect, useState } from "react";
import { Button, Spin, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PAGE_SIZE } from "../../../constants";
import { Link } from "react-router-dom";
import {
	exportSpins,
	fetchSpins,
	resetDownloadCsv,
} from "../../../actions/spinTheWheelOverview";
import { fetchSpinGames } from "../../../actions/spinTheWheelGame";
import { fetchSpinRewards } from "../../../actions/spinTheWheelReward";
import SpinTheWheelOverviewTable from "../../Tables/SpinTheWheelOverview";
import SpinsFilterForm from "../../Forms/SpinsFilter";
import { useRef } from "react";
import { CSVLink } from "react-csv";

const SpinTheWheelSpinPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const { spins, loading } = useSelector((state) => state.fetchSpins);
	const { spinGames, loading: gamesLoading } = useSelector(
		(state) => state.fetchSpinGames,
	);
	const { spinRewards, loading: rewardsLoading } = useSelector(
		(state) => state.fetchSpinRewards,
	);
	const { file } = useSelector((state) => state.exportSpins);

	const [currentPage, setCurrentPage] = useState(1);
	const [pagination, setPagination] = useState({});
	const limit = Number(PAGE_SIZE) || 50;
	const [isExportClick, setIsExportClick] = useState(false);
	const [csvFile, setCsvFile] = useState("");
	const csvLink = useRef();

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchSpins({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		if (spins) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: spins.data.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [spins]);

	useEffect(() => {
		dispatch(fetchSpins({ start: 0, count: PAGE_SIZE }));
		dispatch(fetchSpinGames());
		dispatch(fetchSpinRewards());
	}, []);

	const filterSubmit = (values) => {
		if (!isExportClick) {
			if (values && values !== "") {
				dispatch(
					fetchSpins({
						start: 0,
						count: PAGE_SIZE,
						filter: values,
					}),
				);
			} else {
				dispatch(fetchSpins({ start: 0, count: PAGE_SIZE }));
			}
		} else {
			dispatch(exportSpins({ filter: values }));
			setIsExportClick(false);
		}
	};

	const resetForm = () => {
		form.resetFields();
		dispatch(fetchSpins({ start: 0, count: PAGE_SIZE }));
	};

	const onExportClick = () => {
		setIsExportClick(true);
		form.submit();
	};

	useEffect(() => {
		if (file) {
			setCsvFile(file);
			dispatch(resetDownloadCsv());
			setTimeout(() => {
				csvLink.current.link.click();
			});
		}
	}, [file]);

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Link to={`/spin-the-wheel/overview/details/${record?.id}`}>
					<Button className="btn-table-action-primary" type="link">
						Show
					</Button>
				</Link>
			</span>
		);
	};

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="spin-the-wheel-rates-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Overview</li>
						</ul>
					</div>
				</div>
				<div className="page-filter">
					<CSVLink
						data={csvFile}
						filename={`eys-surveys-export-spins.csv`}
						className="hidden"
						ref={csvLink}
						target="_blank"
					/>
					<SpinsFilterForm
						form={form}
						filterSubmit={filterSubmit}
						resetForm={resetForm}
						spinGames={spinGames}
						gamesLoading={gamesLoading}
						spinRewards={spinRewards}
						rewardsLoading={rewardsLoading}
						onExportClick={onExportClick}
					/>
				</div>
				<div className="page-content">
					{spins && (
						<SpinTheWheelOverviewTable
							rowKey="id"
							dataSource={spins.data.data}
							pagination={pagination}
							onChange2={handleTableChange}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={50}
							withAction={withAction}
						/>
					)}
				</div>
			</div>
		</Spin>
	);
};

export default SpinTheWheelSpinPage;
